import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

// Define Colors & Sizes
const COLORS = {
  purple: "#8B5CF6",
  pink: "#EC4899",
  gray: "#9CA3AF",
  black: "#1F2937",
};

const CARD_SIZE = "23rem";

const StyledIGamingSolution = styled(Box)(({ theme }) => ({
  // minHeight: 'calc(250vh - 82px)',
  position: 'relative',
  overflow: 'visible',
  width: '100%',
  background: theme.palette.background.secondary,
  '& .homeBg': {
    // position: 'absolute',
    height: '100%',
    width: '100%',
    // background: 'red',

    '& .videoElement': {
      position: 'absolute',
      top: 0,
      left: 0,
      height: '130%',
      width: '100%',
      objectFit: 'cover',
      zIndex: -1,
    },
  },

  '& .homeContent': {
    // position: 'absolute',
    height: '100%',
    width: '100%',
    zIndex: 1 /* Ensures content is above the video */,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    // marginTop: theme.spacing(20),
    // paddingLeft: '20%',
    padding: '2% 10% 5% 10%',
    // background: 'linear-gradient(to bottom, black, gray, white)',
    // background: 'linear-gradient(180deg, #000000 48.02%, #FFFFFF 79.45%)',
    background: '#ffffff',


    '& .bannerText': {
      background: theme.customGradients.primary,
      '-webkit-background-clip': 'text',
      '-webkit-text-fill-color': 'transparent',
      boxShadow: theme.palette.boxShadow.secondary,
      font: theme.typography.h3.font,
      fontWeight: 400,
      textAlign: 'center',
    },

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'transparent !important'
    },

    [theme.breakpoints.down('lg')]: {
      // paddingLeft: 1,
      '& .iconBrandLogo': {
        width: '300px',
        height: '100px',
      },
    },
  },

  // '& .carousel': {
  //   position: 'relative',
  //   width: '500px',
  //   height: `${CARD_SIZE}`,
  //   perspective: '500px',
  //   transformStyle: 'preserve-3d',
  //   justifySelf: 'center'
  // },

  '& .card-container': {
    position: 'absolute',
    width: '100%',
    height: '100%',
    transform:
      `rotateY(calc(var(--offset) * 50deg)) 
      scaleY(calc(1 + var(--abs-offset) * -0.4))
      translateZ(calc(var(--abs-offset) * -30rem))
      translateX(calc(var(--direction) * -5rem))`,
    filter: 'blur(calc(var(--abs-offset) * 1rem))',
    transition: 'all 0.3s ease-out',
  },

  '& .card': {
    width: '100%',
    height: '100%',
    padding: '2rem',
    backgroundColor: 'hsl(280deg, 40%, calc(100% - var(--abs-offset) * 50%))',
    borderRadius: '1rem',
    color: `${COLORS.gray}`,
    textAlign: 'justify',
    transition: 'all 0.3s ease-out',

    '& h2': {
      textAlign: 'center',
      fontSize: '2rem',
      fontWeight: 'bold',
      margin: '0 0 0.7em',
      color: `${COLORS.black}`,
    },

    '& p, h2': {
      transition: 'all 0.3s ease-out',
      opacity: 'var(--active)',
    }
  },

  '& .nav': {
    color: 'white',
    fontSize: '5rem',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: '50%',
    zIndex: 2,
    cursor: 'pointer',
    userSelect: 'none',
    background: 'unset',
    border: 'unset',

  },

  '& .left': {
    transform: 'translateX(-500%) translatey(100%)',
    color: '#000000'
  },

  '& .right': {
    right: 0,
    transform: 'translateX(500%) translatey(100%)',
    color: '#000000'
  },

  '& .pageIndicatorContainer': {
    display: 'flex',
    position: 'absolute',
    top: '630px',
    left: '230px',
    '& .pageIndicator': {
      width: '13px',
      height: '13px',
      backgroundColor: '#000',
      borderRadius: '50px',
      marginRight: '10px',
    },
  },

  [theme.breakpoints.down('lg')]: {
    // minHeight: '365vh',
    margin: theme.spacing(0),
    background: '#fff',

    '& .homeContent': {
      marginTop: theme.spacing(0),
      justifyContent: 'center',
      // padding: '10% 5%',
      // padding: '0 15% 0 10%',
      // padding: '0 20px',
      padding: '0',
      background: '#ffffff',
      '& .bannerText': {
        // margin: theme.spacing(0, 1),
        font: theme.typography.h6.font,
        fontWeight: `${500} !important`,
      },

      '& .label2': {
        '@media (width: 320px)': {
          fontSize: '17px !important',
        },
        '@media (width: 344px)': {
          fontSize: '17px !important',
        },
        '@media (width: 360px)': {
          fontSize: '17px !important',
        },
        '@media (width: 540px)': {
          fontSize: '14px !important',
        },
        '@media (width: 768px)': {
          fontSize: '17px !important',
        },
      }
    },

    '.cardMedia': {
      width: '400px',
      height: '216px',
    },
    // '& .carousel': {
    //   position: 'relative',
    //   width: '80px',
    //   height: `${CARD_SIZE}`,
    //   perspective: '500px',
    //   transformStyle: 'preserve-3d'
    // },

    '& .carousel': {
      width: '334px !important',
      height: '400px'
    },

    '& .carousel-root': {
      // height: '450px !important',
      display: 'flex',
      justifyContent: 'center'
    },

    '& .carousel-status': {
      display: 'none'
    },

    '& .control-dots': {
      // top: '286px',
      marginBottom: localStorage.getItem('i18nextLng') === 'en-US' ? 'unset' : '35px',
    },

    '& .dot': {
      background: '#000 !important',
      opacity: '1 !important',
      boxShadow: 'unset !important',
    },

    '& .dot.selected': {
      background: '#00FF00 !important',
      opacity: '1 !important'
    }
  },

  '@media (max-width: 390px)': {
    '& .control-dots': {
      // top: '287px'
    },
  },

  '@media (max-width: 375px)': {
    '& .control-dots': {
      // top: '287px'
    },
  }
}));

export default StyledIGamingSolution;
